import React from "react"
import SVG from "../../images/effects/paper-effect.inline.svg"

export default function PaperEffect({ className }) {
  return <SVG className={className} />
}
